var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFunnel = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#4E4E4E",
  strokeLinecap: "round",
  strokeWidth: 1.25,
  d: "M5.564 6.24C4.527 4.93 5.461 3 7.133 3h9.472a2 2 0 0 1 1.835 2.795l-2.904 6.708a2 2 0 0 0-.164.794v6.266c0 1.114-1.384 1.627-2.11.783l-1.96-2.28a2 2 0 0 1-.483-1.303v-3.185a2 2 0 0 0-.431-1.24z"
})));
export default SvgFunnel;